import React, {useEffect, useRef, useState} from 'react';

function Privacy() {
  const [activeTab, setActiveTab] = useState('data-treatment');
  const refAnalytics = useRef(undefined);
  const refContactForms = useRef(undefined);
  const refPersonalData = useRef(undefined);
  
  return (
    <section className='default-smb-area bg--light'>
      <div className='container page-privacy-content'>
        <div className='row' style={{"marginRight" : "-36px"}}>
        <div className='col-md-12 page-privacy-header'>
          PRIVACY POLICY
        </div>
        <div className='row page-privacy-body'>
          <div className='col-md-3 page-privacy-options' style={{"paddingRight" : "0px"}}>
            <div
              className={`page-privacy-option ${activeTab === 'data-treatment' && 'active'}`}
              onClick={() => {
                setActiveTab('data-treatment');
                refPersonalData.current.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              DATA TREATMENT
            </div>
            <div
              className={`page-privacy-option ${activeTab === 'contact-forms' && 'active'}`}
              onClick={() => {
                setActiveTab('contact-forms');
                refContactForms.current.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              CONTACT FORMS
            </div>
            <div
              className={`page-privacy-option ${activeTab === 'analytics' && 'active'}`}
              onClick={() => {
                setActiveTab('analytics');
                refAnalytics.current.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              ANALYTICS
            </div>
          </div>
          <div className='col-md-9 page-privacy-text' style={{"border": "0px"}}>
            <h3 ref={refPersonalData}>WHAT PERSONAL DATA WE COLLECT AND WHY WE COLLECT IT</h3>
            <h4>COMMENTS</h4>
            <p>
              When visitors leave comments on the site we collect the data shown in the comments form, and also the visitor’s IP address and browser user agent string to help spam detection.
              <br/><br/>
              An anonymized string created from your email address (also called a hash) may be provided to the Gravatar service to see if you are using it. The Gravatar service privacy policy is available here: https://automattic.com/privacy/. After approval of your comment, your profile picture is visible to the public in the context of your comment.
            </p>
            <h4>MEDIA</h4>
            <p>
              If you upload images to the website, you should avoid uploading images with embedded location data (EXIF GPS) included. Visitors to the website can download and extract any location data from images on the website.
            </p>
            
            <h3 ref={refContactForms}>CONTACT FORMS</h3>
            <h4>COOKIES</h4>
            <p>
              If you leave a comment on our site you may opt-in to saving your name, email address and website in cookies. These are for your convenience so that you do not have to fill in your details again when you leave another comment. These cookies will last for one year.
              <br/><br/>
              If you visit our login page, we will set a temporary cookie to determine if your browser accepts cookies. This cookie contains no personal data and is discarded when you close your browser.
              <br/><br/>
              When you log in, we will also set up several cookies to save your login information and your screen display choices. Login cookies last for two days, and screen options cookies last for a year. If you select “Remember Me”, your login will persist for two weeks. If you log out of your account, the login cookies will be removed.
              <br/><br/>
              If you edit or publish an article, an additional cookie will be saved in your browser. This cookie includes no personal data and simply indicates the post ID of the article you just edited. It expires after 1 day.
            </p>
            <h4>EMBEDDED CONTENT FROM OTHER WEBSITES</h4>
            <p>
              Articles on this site may include embedded content (e.g. videos, images, articles, etc.). Embedded content from other websites behaves in the exact same way as if the visitor has visited the other website.
              <br/><br/>
              These websites may collect data about you, use cookies, embed additional third-party tracking, and monitor your interaction with that embedded content, including tracking your interaction with the embedded content if you have an account and are logged in to that website.
            </p>
            
            <h3 ref={refAnalytics}>ANALYTICS</h3>
            <h4>Who we share your data with</h4>
            <p>If you request a password reset, your IP address will be included in the reset email.</p>
            <h4>How long we retain your data</h4>
            <p>
              If you leave a comment, the comment and its metadata are retained indefinitely. This is so we can recognize and approve any follow-up comments automatically instead of holding them in a moderation queue.
              <br/><br/>
              For users that register on our website (if any), we also store the personal information they provide in their user profile. All users can see, edit, or delete their personal information at any time (except they cannot change their username). Website administrators can also see and edit that information.
            </p>
            <h4>What rights you have over your data</h4>
            <p>
              If you have an account on this site, or have left comments, you can request to receive an exported file of the personal data we hold about you, including any data you have provided to us. You can also request that we erase any personal data we hold about you. This does not include any data we are obliged to keep for administrative, legal, or security purposes.
            </p>
            <h4>Where we send your data</h4>
            <p>Visitor comments may be checked through an automated spam detection service.</p>
            <h4>Your contact information</h4>
            <p>We do not share your contact information with partners or third party vendors.</p>
          </div>
        </div>
        </div>
      </div>
    </section>
  );
}

export default Privacy;
